export const AuthProviderHistoryModel = {
    txID: '',
    timestamp: '',
    Record: {
      authProviderName: '',
      authProviderDetails: [],
      updatedBy: '',
      createdBy: '',
      details: []
    }
  };